var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscriptions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.827 16.636a5.947 5.947 0 1 0-9.786-2.15c-4.655 8.023-3.547 18.472 3.322 25.341l.043.043 3.935-3.935-.043-.043c-4.776-4.775-5.76-11.906-2.954-17.653a5.942 5.942 0 0 0 5.483-1.603Z",
    fill: "#F78613"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.406 39.87c5.837 5.805 14.239 7.467 21.544 4.986l-4.602-4.602a15.382 15.382 0 0 1-13.007-4.319l-3.935 3.936Z",
    fill: "#FBB945"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1 31.63a5.947 5.947 0 1 0 4.159 4.021c4.739-8.024 3.673-18.527-3.197-25.436l-3.935 3.935c4.703 4.74 5.694 11.774 2.974 17.48Z",
    fill: "#03AF89"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m18.27 5.2 4.573 4.573a15.384 15.384 0 0 1 13.285 4.376l3.935-3.935-.043-.043C34.138 4.29 25.63 2.632 18.27 5.2Z",
    fill: "#1AD3BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptions);
export default __webpack_public_path__ + "static/media/Subscriptions.ff574e3f81efddbb3332fc39110b8888.svg";
export { ForwardRef as ReactComponent };